import { render, staticRenderFns } from "./ConfirmationPopUp.vue?vue&type=template&id=00b6654c&"
import script from "./ConfirmationPopUp.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports